import { Product } from '@/adapters/catalogAdapterInterface';
import { Action, Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';

/**
 * Plan-based promotion actions (e.g. first year/month free) list the plans they
 * apply to in applicableTo. An empty list means every plan.
 */
export const isActionApplicableToPlan = (action: Action, products: Product[]): boolean => {
  if (!action.applicableTo || action.applicableTo.length === 0) {
    return true;
  }

  return products.some(product => product.type === 'internet' && action.applicableTo.includes(product.id));
};

/**
 * Find a plan-based action (YEAR-OFF, ONE-OFF) on the promotion, only if it
 * applies to the selected plan.
 */
export const findPlanAction = (promotion: Promotion | undefined, code: string, products: Product[]): Action | undefined => {
  return promotion?.actions.find(action => action.actionCatalogObject.code === code && isActionApplicableToPlan(action, products));
};
